<template>
  <div v-if="isShow" class="modalOverlay">
    <div class="modalWrapper">
      <div v-if="isSuccess" v-click-outside="closeSuccessPopup" :class="$style.waitingSendEmail">
        <div :class="$style.waitingSendEmailHeader">
          <CloseButtonIcon :class="$style.waitingSendEmailImg" @click="closeSuccessPopup" />
        </div>
        <EmailSendSuccessIcon :class="$style.isWaitingSendEmailSuccess" />
        <span :class="$style.waitingSendEmailTitle">{{ data.resultSuccessHeaderTitle }}</span>
        <p :class="$style.waitingSendEmailMarkdown">{{ data.resultSuccessMessageTitle }}</p>
        <BitButton @click="closeSuccessPopup">
          {{ data.resultButtonTitle }}
        </BitButton>
      </div>
      <div v-else v-click-outside="closeSuccessPopup" :class="$style.waitingSendEmail">
        <div :class="$style.waitingSendEmailHeader">
          <CloseButtonIcon :class="$style.waitingSendEmailImg" @click="closeSuccessPopup" />
        </div>
        <FailMethodIcon :class="$style.isWaitingSendEmailSuccess" />
        <span :class="$style.failSendEmailTitle">{{ data.resultFailHeaderTitle }}</span>
        <p :class="$style.waitingSendEmailMarkdown">{{ data.resultFailMessageTitle }}</p>
        <BitButton @click="closeSuccessPopup">
          {{ data.resultButtonTitle }}
        </BitButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import CloseButtonIcon from '~/public/images/common/close-button.svg?component';
import FailMethodIcon from '~/public/images/common/failMethod.svg?component';
import EmailSendSuccessIcon from '~/public/images/common/successWaitingSendEmail.svg?component';
import { useStorePopups } from '~/stores/abstract/popups';
import { EPopupName } from '~/types/popups';
import clickOutside from '~/utils/directives/vClickOutside';
import type { ComponentInfoPageBlocksContactUsBlock } from '~/types/infoPages';

const vClickOutside = clickOutside;

defineProps({
  isSuccess: {
    type: Boolean,
    required: true,
  },
  data: {
    type: Object as PropType<ComponentInfoPageBlocksContactUsBlock>,
    required: true,
  },
});

const storePopups = useStorePopups();

/**
 * Getter that show popup if it included in popup queue
 */
const isShow = computed(
  () =>
    storePopups.activePopups &&
    storePopups.activePopups.some((popup) => popup.name === EPopupName.sendMessagePopup)
);
/**
 * Method that close popup
 */
const closeSuccessPopup = () => {
  storePopups.closePopup(EPopupName.sendMessagePopup);
};
</script>

<style module lang="scss" src="./successSendEmail.scss"></style>
